import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { CheckIcon } from '@heroicons/react/24/outline'
import { StepsRail } from '../../jiraWizard.styles'
import { WizardStepDefinition } from '../wizard.constants'

interface Props {
  steps: WizardStepDefinition[]
  activeStep: number
  completedKeys: string[]
  onStepClick: (index: number) => void
}

/* The wizard's left rail: one numbered item per step, filled while active and
 * checked once the server reports the step completed. Only completed steps are
 * navigable — a step ahead of the server's current one has nothing to show. */
const WizardStepper: FC<Props> = ({ steps, activeStep, completedKeys, onStepClick }) => (
  <StepsRail>
    <Typography className="steps-label">Steps</Typography>

    {steps.map((step, index) => {
      const isActive = index === activeStep
      const isCompleted = !isActive && completedKeys.includes(step.key)
      const navigable = !isActive && (isCompleted || index < activeStep)
      const state = isActive ? 'active' : isCompleted ? 'completed' : 'upcoming'

      return (
        <Box
          component="button"
          type="button"
          key={step.key}
          className={`step-item ${isActive ? 'active' : ''} ${navigable ? 'navigable' : ''}`}
          disabled={!navigable}
          onClick={() => navigable && onStepClick(index)}
        >
          <Box className={`step-circle ${state}`}>
            {isCompleted ? <CheckIcon width={16} height={16} /> : index + 1}
          </Box>
          <Typography className="step-text">{step.title}</Typography>
        </Box>
      )
    })}
  </StepsRail>
)

export default WizardStepper
